import axios from "axios";

function getBonusStatus() {
    return axios.get("/api/v1/tutor/monthly-score/bonus-status")
}

function getAllScores() {
    return axios.get("/api/v1/tutor/scores/all")
}

function markResetModalShown() {
    return axios.post("/api/v1/tutor/monthly-score/mark-modal-shown")
}

export const tutorMonthlyScoreService = {
    getBonusStatus,
    getAllScores,
    markResetModalShown,
}
